import HeaderBorderButton from "@/components/UI/HeaderBorderButton.vue";
import HeaderButton from "@/components/UI/HeaderButton.vue";

export default [
    HeaderBorderButton,
    HeaderButton
]